import felix_lex_img from '../../../img/articles/felix_the_cat/felix_lexington.webp';
import felix1_img from '../../../img/articles/felix_the_cat/IMG_20240121_220314.jpg'
import felix1b_img from '../../../img/articles/felix_the_cat/IMG_20240122_001038.jpg'
import felix1c_img from '../../../img/articles/felix_the_cat/IMG_20240216_232740.jpg'
import felix1d_img from '../../../img/articles/felix_the_cat/IMG_20240217_015148.jpg'
import felix2_img from '../../../img/articles/felix_the_cat/IMG_20240223_003715.jpg'
import felix3_img from '../../../img/articles/felix_the_cat/IMG_20240223_003553.jpg'
import felix4_img from '../../../img/articles/felix_the_cat/20240331_002905.jpg'
import felix4b_img from '../../../img/articles/felix_the_cat/20240331_100030b.jpg'

import imodeler_logo from '../../../img/imodeler.png';

export default function FelixTheCat(props) {



    let felix_es = (<div>Tengo en mi mesa de trabajo un diorama de un Grumman F4F Wilcat que llamo Felix the Cat. El contexto es éste: el 4 de Marzo de 2018 el barco Petrel encontró el pecio 
        del portaaviones USS Lexington (CV-2). Entre los restos desperdigados en el fondo del mar se encontró este F4F con el logo del gato Félix en su costado:
        <center><img src={felix_lex_img} class="article-img" alt="Felix"/></center>
        Esta imagen me fascinó tanto que deseé replicar este avión en el fondo del mar. Para esto, utilicé una caja de F4F Wilcat 1:72 de Airfix, de excelente factura, y la destruí.
        <center><img src={felix1_img} class="article-img" alt="Felix"/>  <img src={felix1b_img} class="article-img" alt="Felix"/> <img src={felix1c_img} class="article-img" alt="Felix"/>
        <img src={felix1d_img} class="article-img" alt="Felix"/></center>
        Construí una base barrosa a guisa de fondo marino, y diseñé una plataforma giratoria para poder cortarla en forma circular. Esta plataforma se puede encontrar <a href="https://www.thingiverse.com/thing:6563931" target='_blank' rel="noreferrer">acá en Thingiverse</a>.
        <center><img src={felix2_img} class="article-img" alt="Felix"/> <img src={felix3_img} class="article-img" alt="Felix"/></center>
        Tras la pintura y el weathering el resultado es realmente notable. Luego, incorporé resina y la teñí azul.
        <center><img src={felix4_img} class="article-img" alt="Felix"/> <img src={felix4b_img} class="article-img" alt="Felix"/></center>
        Lamentablemente el tercer kilo de resina se curó mal y deberé deshacer parte del trabajo. ¡Y acá voy!
        
        </div>);
    let felix_en = (<div>I have in my desk a Grumman F4F Wildcat diorama named Felix the Cat. The context is this: on March 4th, 2018, the oceanographic research vessel Pretrel
        found the wreck of the carrier USS Lexington (CV-2). Among the rests scattered on the ocean floor it was found this eerie F4F the Felix the Cat logo on its side:
        <center><img src={felix_lex_img} class="article-img" alt="Felix"/></center>
        This image fascinated me so much that I wished to replicate this plane in the bottom of the sea. For this, I used an excelent F4F Wildcat 1:72 Arfix kit, and I destroyed it.
        <center><img src={felix1_img} class="article-img" alt="Felix"/>  <img src={felix1b_img} class="article-img" alt="Felix"/> <img src={felix1c_img} class="article-img" alt="Felix"/>
        <img src={felix1d_img} class="article-img" alt="Felix"/></center>
        I built a muddy base as the sea bottom, and designed a turntable to cut it and sand it circular. This turntable can be found <a href="https://www.thingiverse.com/thing:6563931" target='_blank' rel="noreferrer">here at Thingiverse</a>.
        <center><img src={felix2_img} class="article-img" alt="Felix"/> <img src={felix3_img} class="article-img" alt="Felix"/></center>
        After painting and weathering the result is really something. I started adding the resin toned blue.
        <center><img src={felix4_img} class="article-img" alt="Felix"/> <img src={felix4b_img} class="article-img" alt="Felix"/></center>
        Sadly the third resin kilo cured wrong and I'll have to cut it off and redo it. And here is where I am now!
        </div>);

    let felix = felix_es;

    switch(props.lang){
        case "en":
            felix = felix_en;
        default:
            break;
    }

    return (
        <article className='article' name='felix'>
            <a href='https://www.imodeler.com/members/alfredo_cofre/' target='_blank' rel='noreferrer'>
                <img src={imodeler_logo} width="32px" alt="imodeler"/>
            </a>
            <p>{felix}</p>
        </article>
    );
}